var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4040",
    "data-name": "Group 4040",
    transform: "translate(-292 -737)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6719",
    "data-name": "Rectangle 6719",
    width: 30,
    height: 30,
    rx: 5,
    transform: "translate(292 737)",
    fill: "#c2fae5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-save-7142572",
    transform: "translate(286.917 735.664)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32561",
    "data-name": "Path 32561",
    d: "M26.756,12.319,23.168,8.731a1.159,1.159,0,0,0-.831-.348l-1.373-.008c0,.487,0,1.85,0,2.358a.794.794,0,0,1-.792.792H15.979a.791.791,0,0,1-.792-.792c0-.507,0-1.9,0-2.394l-.914,0a1.2,1.2,0,0,0-1.191,1.187V22.973A1.188,1.188,0,0,0,14.27,24.16h.656c0-.343,0-5.142,0-5.638a.791.791,0,0,1,.792-.792h8.751a.791.791,0,0,1,.792.792c0,.5,0,5.272,0,5.638h.656A1.188,1.188,0,0,0,27.1,22.973V13.158a1.17,1.17,0,0,0-.348-.839Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32562",
    "data-name": "Path 32562",
    d: "M26.961,66.826v.792h.807V63.7a.4.4,0,0,1,.792,0c0,.586,0,3.394,0,3.917h.8c0-.506,0-3.348,0-3.917a.4.4,0,0,1,.792,0v3.917h.8V63.7a.4.4,0,0,1,.792,0v3.917h.8V63.7a.4.4,0,1,1,.791,0v3.917h.8c0-.507,0-3.347,0-3.917a.4.4,0,0,1,.792,0c0,.586,0,3.394,0,3.917h.807c-.009-.369.006-5.123,0-5.638H26.962v4.846Z",
    transform: "translate(-11.243 -43.457)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32563",
    "data-name": "Path 32563",
    d: "M32.529,9.21V8.419l-4.193-.024v2.386h4.193Z",
    transform: "translate(-12.356 -0.048)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.48f021b745d55aa0bdfd53fa54561c10.svg";
export { ForwardRef as ReactComponent };